import {
  Col,
  Container,
  Nav,
  Row,
  Tab,
  TabContainerProps,
} from 'react-bootstrap';
import { useLocation } from 'react-router-dom';

export type menuTabsProps = {
  name: string;
  content: React.ReactNode;
  icon: React.ReactNode;
  href?: string;
};

export type customMenuTabsProps = TabContainerProps &
  React.PropsWithChildren<{
    tabs: menuTabsProps[];
  }>;

const MenuTabs = ({ tabs }: customMenuTabsProps) => {
  const { pathname } = useLocation();
  const selectedTabIndex = tabs.findIndex((tab: menuTabsProps) => {
    if(tab.href!.indexOf(pathname) > -1) {
      return true;
    }
    return false;
  });

  return (
    <Container className="custom-menu-tabs-component cnd-custom-container-large px-7">
      <Tab.Container id="menu-tabs" defaultActiveKey={selectedTabIndex.toString()} activeKey={selectedTabIndex.toString()}>
        <Row>
          <Col className="col-12 col-lg-3 tabs-cols">
            <Nav variant="pills" className="flex-column">
              {tabs.map((tab, i) => (
                <Nav.Item key={i}>
                  <Nav.Link eventKey={i} href={tab.href}>
                    <span>{tab.icon}</span>
                    <span className="name-span">{tab.name}</span>
                  </Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
          </Col>
          <Col className={'p-0 ms-lg-12'}>
            <Tab.Content>
              {tabs.map((tab, i) => (
                <Tab.Pane key={i} eventKey={i}>
                  {tab.content}
                </Tab.Pane>
              ))}
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </Container>
  );
};

export default MenuTabs;
